import randFloat from "./randFloat";

function pickRandomlyFromArray<T>(array: T[]) {
  return array[Math.floor(randFloat() * array.length)];
}

export default pickRandomlyFromArray;
